export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Cursor: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  InitDefaultsObject: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AuditLog = {
  __typename?: 'AuditLog';
  action: Scalars['String']['output'];
  actionTimestamp: Scalars['Datetime']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['BigInt']['output'];
  rowData?: Maybe<Scalars['JSON']['output']>;
  schemaName: Scalars['String']['output'];
  tableName: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedColumnNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * A condition to be used against `AuditLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AuditLogCondition = {
  /** Checks for equality with the object’s `action` field. */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `actionTimestamp` field. */
  actionTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `rowData` field. */
  rowData?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `schemaName` field. */
  schemaName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tableName` field. */
  tableName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedColumnNames` field. */
  updatedColumnNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A filter to be used against `AuditLog` object types. All fields are combined with a logical ‘and.’ */
export type AuditLogFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<StringFilter>;
  /** Filter by the object’s `actionTimestamp` field. */
  actionTimestamp?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditLogFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditLogFilter>>;
  /** Filter by the object’s `rowData` field. */
  rowData?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `schemaName` field. */
  schemaName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tableName` field. */
  tableName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedColumnNames` field. */
  updatedColumnNames?: InputMaybe<StringListFilter>;
};

/** A connection to a list of `AuditLog` values. */
export type AuditLogsConnection = {
  __typename?: 'AuditLogsConnection';
  /** A list of edges which contains the `AuditLog` and cursor to aid in pagination. */
  edges: Array<AuditLogsEdge>;
  /** A list of `AuditLog` objects. */
  nodes: Array<AuditLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AuditLog` edge in the connection. */
export type AuditLogsEdge = {
  __typename?: 'AuditLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AuditLog` at the end of the edge. */
  node: AuditLog;
};

/** Methods to use when ordering `AuditLog`. */
export enum AuditLogsOrderBy {
  ActionAsc = 'ACTION_ASC',
  ActionDesc = 'ACTION_DESC',
  ActionTimestampAsc = 'ACTION_TIMESTAMP_ASC',
  ActionTimestampDesc = 'ACTION_TIMESTAMP_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RowDataAsc = 'ROW_DATA_ASC',
  RowDataDesc = 'ROW_DATA_DESC',
  SchemaNameAsc = 'SCHEMA_NAME_ASC',
  SchemaNameDesc = 'SCHEMA_NAME_DESC',
  TableNameAsc = 'TABLE_NAME_ASC',
  TableNameDesc = 'TABLE_NAME_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedColumnNamesAsc = 'UPDATED_COLUMN_NAMES_ASC',
  UpdatedColumnNamesDesc = 'UPDATED_COLUMN_NAMES_DESC'
}

export type AuthenticateTenantAdminInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type AuthenticateTenantAdminPayload = {
  __typename?: 'AuthenticateTenantAdminPayload';
  /** Access Token containing permissions of the Tenant Admin */
  accessToken: Scalars['String']['output'];
  /** Access Token expiration timeout */
  expiresInSeconds: Scalars['Int']['output'];
  /** System generated password has been changed */
  passwordChanged: Scalars['Boolean']['output'];
  /** Name of the Tenant Administrator */
  tenantAdminEmail: Scalars['String']['output'];
  /** Name of the Tenant Administrator */
  tenantAdminName: Scalars['String']['output'];
  /** Name of the Tenant */
  tenantName: Scalars['String']['output'];
  /** Access Token type to use when making client requests */
  tokenType: Scalars['String']['output'];
};

export type AuthenticateWithSsoTokenInput = {
  ssoToken: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type ChangeServiceStateInput = {
  commandToSend: ServiceCommand;
  environmentId: Scalars['UUID']['input'];
  managedServiceId: Scalars['String']['input'];
};

export type ChangeServiceStatePayload = {
  __typename?: 'ChangeServiceStatePayload';
  successfullySent: Scalars['Boolean']['output'];
};

export type ChangeTenantAdminPasswordInput = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum ConflictResolution {
  OverwriteAll = 'OVERWRITE_ALL',
  OverwriteNonProtected = 'OVERWRITE_NON_PROTECTED',
  Skip = 'SKIP'
}

/** All input for the create `EmailWhitelistPattern` mutation. */
export type CreateEmailWhitelistPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EmailWhitelistPattern` to be created by this mutation. */
  emailWhitelistPattern: EmailWhitelistPatternInput;
};

/** The output of our create `EmailWhitelistPattern` mutation. */
export type CreateEmailWhitelistPatternPayload = {
  __typename?: 'CreateEmailWhitelistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailWhitelistPattern` that was created by this mutation. */
  emailWhitelistPattern?: Maybe<EmailWhitelistPattern>;
  /** An edge for our `EmailWhitelistPattern`. May be used by Relay 1. */
  emailWhitelistPatternEdge?: Maybe<EmailWhitelistPatternsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EmailWhitelistPattern` mutation. */
export type CreateEmailWhitelistPatternPayloadEmailWhitelistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailWhitelistPatternsOrderBy>>;
};

/** All input for the create `EmailWhitelistPatternRole` mutation. */
export type CreateEmailWhitelistPatternRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EmailWhitelistPatternRole` to be created by this mutation. */
  emailWhitelistPatternRole: EmailWhitelistPatternRoleInput;
};

/** The output of our create `EmailWhitelistPatternRole` mutation. */
export type CreateEmailWhitelistPatternRolePayload = {
  __typename?: 'CreateEmailWhitelistPatternRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EmailWhitelistPattern` that is related to this `EmailWhitelistPatternRole`. */
  emailWhitelistPattern?: Maybe<EmailWhitelistPattern>;
  /** The `EmailWhitelistPatternRole` that was created by this mutation. */
  emailWhitelistPatternRole?: Maybe<EmailWhitelistPatternRole>;
  /** An edge for our `EmailWhitelistPatternRole`. May be used by Relay 1. */
  emailWhitelistPatternRoleEdge?: Maybe<EmailWhitelistPatternRolesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EmailWhitelistPatternRole` mutation. */
export type CreateEmailWhitelistPatternRolePayloadEmailWhitelistPatternRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailWhitelistPatternRolesOrderBy>>;
};

/** All input for the create `Environment` mutation. */
export type CreateEnvironmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Environment` to be created by this mutation. */
  environment: EnvironmentInput;
};

/** The output of our create `Environment` mutation. */
export type CreateEnvironmentPayload = {
  __typename?: 'CreateEnvironmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Environment` that was created by this mutation. */
  environment?: Maybe<Environment>;
  /** An edge for our `Environment`. May be used by Relay 1. */
  environmentEdge?: Maybe<EnvironmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Environment` mutation. */
export type CreateEnvironmentPayloadEnvironmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};

/** All input for the create `IdServiceConfiguration` mutation. */
export type CreateIdServiceConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IdServiceConfiguration` to be created by this mutation. */
  idServiceConfiguration: IdServiceConfigurationInput;
};

/** The output of our create `IdServiceConfiguration` mutation. */
export type CreateIdServiceConfigurationPayload = {
  __typename?: 'CreateIdServiceConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `IdServiceConfiguration`. */
  environment?: Maybe<Environment>;
  /** The `IdServiceConfiguration` that was created by this mutation. */
  idServiceConfiguration?: Maybe<IdServiceConfiguration>;
  /** An edge for our `IdServiceConfiguration`. May be used by Relay 1. */
  idServiceConfigurationEdge?: Maybe<IdServiceConfigurationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IdServiceConfiguration` mutation. */
export type CreateIdServiceConfigurationPayloadIdServiceConfigurationEdgeArgs = {
  orderBy?: InputMaybe<Array<IdServiceConfigurationsOrderBy>>;
};

/** All input for the create `IdpConfiguration` mutation. */
export type CreateIdpConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IdpConfiguration` to be created by this mutation. */
  idpConfiguration: IdpConfigurationInput;
};

/** The output of our create `IdpConfiguration` mutation. */
export type CreateIdpConfigurationPayload = {
  __typename?: 'CreateIdpConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `IdpConfiguration`. */
  environment?: Maybe<Environment>;
  /** The `IdpConfiguration` that was created by this mutation. */
  idpConfiguration?: Maybe<IdpConfiguration>;
  /** An edge for our `IdpConfiguration`. May be used by Relay 1. */
  idpConfigurationEdge?: Maybe<IdpConfigurationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IdpConfiguration` mutation. */
export type CreateIdpConfigurationPayloadIdpConfigurationEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpConfigurationsOrderBy>>;
};

/** All input for the create `ServiceAccount` mutation. */
export type CreateServiceAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ServiceAccount` to be created by this mutation. */
  serviceAccount: ServiceAccountInput;
};

/** The output of our create `ServiceAccount` mutation. */
export type CreateServiceAccountPayload = {
  __typename?: 'CreateServiceAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `ServiceAccount`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ServiceAccount` that was created by this mutation. */
  serviceAccount?: Maybe<ServiceAccount>;
  /** An edge for our `ServiceAccount`. May be used by Relay 1. */
  serviceAccountEdge?: Maybe<ServiceAccountsEdge>;
};


/** The output of our create `ServiceAccount` mutation. */
export type CreateServiceAccountPayloadServiceAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceAccountsOrderBy>>;
};

/** All input for the create `ServiceAccountPermissionAssignment` mutation. */
export type CreateServiceAccountPermissionAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ServiceAccountPermissionAssignment` to be created by this mutation. */
  serviceAccountPermissionAssignment: ServiceAccountPermissionAssignmentInput;
};

/** The output of our create `ServiceAccountPermissionAssignment` mutation. */
export type CreateServiceAccountPermissionAssignmentPayload = {
  __typename?: 'CreateServiceAccountPermissionAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `ServiceAccountPermissionAssignment`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ServiceAccount` that is related to this `ServiceAccountPermissionAssignment`. */
  serviceAccount?: Maybe<ServiceAccount>;
  /** The `ServiceAccountPermissionAssignment` that was created by this mutation. */
  serviceAccountPermissionAssignment?: Maybe<ServiceAccountPermissionAssignment>;
  /** An edge for our `ServiceAccountPermissionAssignment`. May be used by Relay 1. */
  serviceAccountPermissionAssignmentEdge?: Maybe<ServiceAccountPermissionAssignmentsEdge>;
};


/** The output of our create `ServiceAccountPermissionAssignment` mutation. */
export type CreateServiceAccountPermissionAssignmentPayloadServiceAccountPermissionAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceAccountPermissionAssignmentsOrderBy>>;
};

/** All input for the `createTenantAdmin` mutation. */
export type CreateTenantAdminInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** The output of our `createTenantAdmin` mutation. */
export type CreateTenantAdminPayload = {
  __typename?: 'CreateTenantAdminPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  tenantAdmin?: Maybe<TenantAdmin>;
  /** An edge for our `TenantAdmin`. May be used by Relay 1. */
  tenantAdminEdge?: Maybe<TenantAdminsEdge>;
};


/** The output of our `createTenantAdmin` mutation. */
export type CreateTenantAdminPayloadTenantAdminEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantAdminsOrderBy>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** All input for the `deleteEmailWhitelistPattern` mutation. */
export type DeleteEmailWhitelistPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `EmailWhitelistPattern` mutation. */
export type DeleteEmailWhitelistPatternPayload = {
  __typename?: 'DeleteEmailWhitelistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailWhitelistPattern` that was deleted by this mutation. */
  emailWhitelistPattern?: Maybe<EmailWhitelistPattern>;
  /** An edge for our `EmailWhitelistPattern`. May be used by Relay 1. */
  emailWhitelistPatternEdge?: Maybe<EmailWhitelistPatternsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EmailWhitelistPattern` mutation. */
export type DeleteEmailWhitelistPatternPayloadEmailWhitelistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailWhitelistPatternsOrderBy>>;
};

/** All input for the `deleteEmailWhitelistPatternRole` mutation. */
export type DeleteEmailWhitelistPatternRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `EmailWhitelistPatternRole` mutation. */
export type DeleteEmailWhitelistPatternRolePayload = {
  __typename?: 'DeleteEmailWhitelistPatternRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EmailWhitelistPattern` that is related to this `EmailWhitelistPatternRole`. */
  emailWhitelistPattern?: Maybe<EmailWhitelistPattern>;
  /** The `EmailWhitelistPatternRole` that was deleted by this mutation. */
  emailWhitelistPatternRole?: Maybe<EmailWhitelistPatternRole>;
  /** An edge for our `EmailWhitelistPatternRole`. May be used by Relay 1. */
  emailWhitelistPatternRoleEdge?: Maybe<EmailWhitelistPatternRolesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EmailWhitelistPatternRole` mutation. */
export type DeleteEmailWhitelistPatternRolePayloadEmailWhitelistPatternRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailWhitelistPatternRolesOrderBy>>;
};

/** All input for the `deleteEnvironment` mutation. */
export type DeleteEnvironmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Environment` mutation. */
export type DeleteEnvironmentPayload = {
  __typename?: 'DeleteEnvironmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Environment` that was deleted by this mutation. */
  environment?: Maybe<Environment>;
  /** An edge for our `Environment`. May be used by Relay 1. */
  environmentEdge?: Maybe<EnvironmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Environment` mutation. */
export type DeleteEnvironmentPayloadEnvironmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};

/** All input for the `deleteIdpConfiguration` mutation. */
export type DeleteIdpConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `IdpConfiguration` mutation. */
export type DeleteIdpConfigurationPayload = {
  __typename?: 'DeleteIdpConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `IdpConfiguration`. */
  environment?: Maybe<Environment>;
  /** The `IdpConfiguration` that was deleted by this mutation. */
  idpConfiguration?: Maybe<IdpConfiguration>;
  /** An edge for our `IdpConfiguration`. May be used by Relay 1. */
  idpConfigurationEdge?: Maybe<IdpConfigurationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IdpConfiguration` mutation. */
export type DeleteIdpConfigurationPayloadIdpConfigurationEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpConfigurationsOrderBy>>;
};

/** All input for the `deleteServiceAccountByClientId` mutation. */
export type DeleteServiceAccountByClientIdInput = {
  clientId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `deleteServiceAccount` mutation. */
export type DeleteServiceAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ServiceAccount` mutation. */
export type DeleteServiceAccountPayload = {
  __typename?: 'DeleteServiceAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `ServiceAccount`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ServiceAccount` that was deleted by this mutation. */
  serviceAccount?: Maybe<ServiceAccount>;
  /** An edge for our `ServiceAccount`. May be used by Relay 1. */
  serviceAccountEdge?: Maybe<ServiceAccountsEdge>;
};


/** The output of our delete `ServiceAccount` mutation. */
export type DeleteServiceAccountPayloadServiceAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceAccountsOrderBy>>;
};

/** All input for the `deleteServiceAccountPermissionAssignment` mutation. */
export type DeleteServiceAccountPermissionAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ServiceAccountPermissionAssignment` mutation. */
export type DeleteServiceAccountPermissionAssignmentPayload = {
  __typename?: 'DeleteServiceAccountPermissionAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `ServiceAccountPermissionAssignment`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ServiceAccount` that is related to this `ServiceAccountPermissionAssignment`. */
  serviceAccount?: Maybe<ServiceAccount>;
  /** The `ServiceAccountPermissionAssignment` that was deleted by this mutation. */
  serviceAccountPermissionAssignment?: Maybe<ServiceAccountPermissionAssignment>;
  /** An edge for our `ServiceAccountPermissionAssignment`. May be used by Relay 1. */
  serviceAccountPermissionAssignmentEdge?: Maybe<ServiceAccountPermissionAssignmentsEdge>;
};


/** The output of our delete `ServiceAccountPermissionAssignment` mutation. */
export type DeleteServiceAccountPermissionAssignmentPayloadServiceAccountPermissionAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceAccountPermissionAssignmentsOrderBy>>;
};

/** All input for the `deleteTenantAdmin` mutation. */
export type DeleteTenantAdminInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `TenantAdmin` mutation. */
export type DeleteTenantAdminPayload = {
  __typename?: 'DeleteTenantAdminPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TenantAdmin` that was deleted by this mutation. */
  tenantAdmin?: Maybe<TenantAdmin>;
  /** An edge for our `TenantAdmin`. May be used by Relay 1. */
  tenantAdminEdge?: Maybe<TenantAdminsEdge>;
};


/** The output of our delete `TenantAdmin` mutation. */
export type DeleteTenantAdminPayloadTenantAdminEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantAdminsOrderBy>>;
};

export type EmailWhitelistPattern = {
  __typename?: 'EmailWhitelistPattern';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `EmailWhitelistPatternRole`. */
  emailDomainRoles: EmailWhitelistPatternRolesConnection;
  emailPattern: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
};


export type EmailWhitelistPatternEmailDomainRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailWhitelistPatternRoleCondition>;
  filter?: InputMaybe<EmailWhitelistPatternRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailWhitelistPatternRolesOrderBy>>;
};

/**
 * A condition to be used against `EmailWhitelistPattern` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EmailWhitelistPatternCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `emailPattern` field. */
  emailPattern?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `EmailWhitelistPattern` object types. All fields are combined with a logical ‘and.’ */
export type EmailWhitelistPatternFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmailWhitelistPatternFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailDomainRoles` relation. */
  emailDomainRoles?: InputMaybe<EmailWhitelistPatternToManyEmailWhitelistPatternRoleFilter>;
  /** Some related `emailDomainRoles` exist. */
  emailDomainRolesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `emailPattern` field. */
  emailPattern?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmailWhitelistPatternFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmailWhitelistPatternFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `EmailWhitelistPattern` */
export type EmailWhitelistPatternInput = {
  emailPattern: Scalars['String']['input'];
  environmentId: Scalars['UUID']['input'];
};

/** Represents an update to a `EmailWhitelistPattern`. Fields that are set will be updated. */
export type EmailWhitelistPatternPatch = {
  emailPattern?: InputMaybe<Scalars['String']['input']>;
};

export type EmailWhitelistPatternRole = {
  __typename?: 'EmailWhitelistPatternRole';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  /** Reads a single `EmailWhitelistPattern` that is related to this `EmailWhitelistPatternRole`. */
  emailWhitelistPattern?: Maybe<EmailWhitelistPattern>;
  emailWhitelistPatternId: Scalars['UUID']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  userRoleDescription?: Maybe<Scalars['String']['output']>;
  userRoleId: Scalars['UUID']['output'];
  userRoleName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `EmailWhitelistPatternRole` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EmailWhitelistPatternRoleCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `emailWhitelistPatternId` field. */
  emailWhitelistPatternId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `EmailWhitelistPatternRole` object types. All fields are combined with a logical ‘and.’ */
export type EmailWhitelistPatternRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmailWhitelistPatternRoleFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailWhitelistPattern` relation. */
  emailWhitelistPattern?: InputMaybe<EmailWhitelistPatternFilter>;
  /** Filter by the object’s `emailWhitelistPatternId` field. */
  emailWhitelistPatternId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmailWhitelistPatternRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmailWhitelistPatternRoleFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userRoleDescription` field. */
  userRoleDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userRoleName` field. */
  userRoleName?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `EmailWhitelistPatternRole` */
export type EmailWhitelistPatternRoleInput = {
  emailWhitelistPatternId: Scalars['UUID']['input'];
  environmentId: Scalars['UUID']['input'];
  userRoleId: Scalars['UUID']['input'];
};

/** Represents an update to a `EmailWhitelistPatternRole`. Fields that are set will be updated. */
export type EmailWhitelistPatternRolePatch = {
  userRoleId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `EmailWhitelistPatternRole` values. */
export type EmailWhitelistPatternRolesConnection = {
  __typename?: 'EmailWhitelistPatternRolesConnection';
  /** A list of edges which contains the `EmailWhitelistPatternRole` and cursor to aid in pagination. */
  edges: Array<EmailWhitelistPatternRolesEdge>;
  /** A list of `EmailWhitelistPatternRole` objects. */
  nodes: Array<EmailWhitelistPatternRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailWhitelistPatternRole` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EmailWhitelistPatternRole` edge in the connection. */
export type EmailWhitelistPatternRolesEdge = {
  __typename?: 'EmailWhitelistPatternRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmailWhitelistPatternRole` at the end of the edge. */
  node: EmailWhitelistPatternRole;
};

/** Methods to use when ordering `EmailWhitelistPatternRole`. */
export enum EmailWhitelistPatternRolesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EmailWhitelistPatternIdAsc = 'EMAIL_WHITELIST_PATTERN_ID_ASC',
  EmailWhitelistPatternIdDesc = 'EMAIL_WHITELIST_PATTERN_ID_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UserRoleIdAsc = 'USER_ROLE_ID_ASC',
  UserRoleIdDesc = 'USER_ROLE_ID_DESC'
}

/** A filter to be used against many `EmailWhitelistPatternRole` object types. All fields are combined with a logical ‘and.’ */
export type EmailWhitelistPatternToManyEmailWhitelistPatternRoleFilter = {
  /** Every related `EmailWhitelistPatternRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmailWhitelistPatternRoleFilter>;
  /** No related `EmailWhitelistPatternRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmailWhitelistPatternRoleFilter>;
  /** Some related `EmailWhitelistPatternRole` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmailWhitelistPatternRoleFilter>;
};

/** A connection to a list of `EmailWhitelistPattern` values. */
export type EmailWhitelistPatternsConnection = {
  __typename?: 'EmailWhitelistPatternsConnection';
  /** A list of edges which contains the `EmailWhitelistPattern` and cursor to aid in pagination. */
  edges: Array<EmailWhitelistPatternsEdge>;
  /** A list of `EmailWhitelistPattern` objects. */
  nodes: Array<EmailWhitelistPattern>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailWhitelistPattern` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EmailWhitelistPattern` edge in the connection. */
export type EmailWhitelistPatternsEdge = {
  __typename?: 'EmailWhitelistPatternsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmailWhitelistPattern` at the end of the edge. */
  node: EmailWhitelistPattern;
};

/** Methods to use when ordering `EmailWhitelistPattern`. */
export enum EmailWhitelistPatternsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EmailPatternAsc = 'EMAIL_PATTERN_ASC',
  EmailPatternDesc = 'EMAIL_PATTERN_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type Environment = {
  __typename?: 'Environment';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `EnvironmentManagedService`. */
  environmentManagedServices: EnvironmentManagedServicesConnection;
  environmentTemplateId: Scalars['String']['output'];
  environmentTemplateName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `IdServiceConfiguration`. */
  idServiceConfiguration: IdServiceConfigurationsConnection;
  /** Reads and enables pagination through a set of `IdpConfiguration`. */
  idpConfigurations: IdpConfigurationsConnection;
  initDefaults?: Maybe<Scalars['InitDefaultsObject']['output']>;
  isDevelopment: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orchestrationErrorDetails?: Maybe<Scalars['JSON']['output']>;
  orchestrationState: OrchestrationState;
  /** Reads and enables pagination through a set of `ServiceAccount`. */
  serviceAccounts: ServiceAccountsConnection;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
};


export type EnvironmentEnvironmentManagedServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentManagedServiceCondition>;
  filter?: InputMaybe<EnvironmentManagedServiceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentManagedServicesOrderBy>>;
};


export type EnvironmentIdServiceConfigurationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IdServiceConfigurationCondition>;
  filter?: InputMaybe<IdServiceConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IdServiceConfigurationsOrderBy>>;
};


export type EnvironmentIdpConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IdpConfigurationCondition>;
  filter?: InputMaybe<IdpConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IdpConfigurationsOrderBy>>;
};


export type EnvironmentServiceAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceAccountCondition>;
  filter?: InputMaybe<ServiceAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceAccountsOrderBy>>;
};

/**
 * A condition to be used against `Environment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EnvironmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `enabled` field. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `environmentTemplateId` field. */
  environmentTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `initDefaults` field. */
  initDefaults?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Checks for equality with the object’s `isDevelopment` field. */
  isDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orchestrationErrorDetails` field. */
  orchestrationErrorDetails?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `orchestrationState` field. */
  orchestrationState?: InputMaybe<OrchestrationState>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Environment` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `enabled` field. */
  enabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `environmentManagedServices` relation. */
  environmentManagedServices?: InputMaybe<EnvironmentToManyEnvironmentManagedServiceFilter>;
  /** Some related `environmentManagedServices` exist. */
  environmentManagedServicesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `environmentTemplateId` field. */
  environmentTemplateId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentTemplateName` field. */
  environmentTemplateName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `idServiceConfiguration` relation. */
  idServiceConfiguration?: InputMaybe<EnvironmentToManyIdServiceConfigurationFilter>;
  /** Some related `idServiceConfiguration` exist. */
  idServiceConfigurationExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `idpConfigurations` relation. */
  idpConfigurations?: InputMaybe<EnvironmentToManyIdpConfigurationFilter>;
  /** Some related `idpConfigurations` exist. */
  idpConfigurationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `initDefaults` field. */
  initDefaults?: InputMaybe<InitDefaultsObjectFilter>;
  /** Filter by the object’s `isDevelopment` field. */
  isDevelopment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentFilter>>;
  /** Filter by the object’s `orchestrationErrorDetails` field. */
  orchestrationErrorDetails?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `orchestrationState` field. */
  orchestrationState?: InputMaybe<OrchestrationStateFilter>;
  /** Filter by the object’s `serviceAccountPermissionAssignmentsByTenantIdAndEnvironmentId` relation. */
  serviceAccountPermissionAssignmentsByTenantIdAndEnvironmentId?: InputMaybe<EnvironmentToManyServiceAccountPermissionAssignmentFilter>;
  /** Some related `serviceAccountPermissionAssignmentsByTenantIdAndEnvironmentId` exist. */
  serviceAccountPermissionAssignmentsByTenantIdAndEnvironmentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `serviceAccounts` relation. */
  serviceAccounts?: InputMaybe<EnvironmentToManyServiceAccountFilter>;
  /** Some related `serviceAccounts` exist. */
  serviceAccountsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Environment` */
export type EnvironmentInput = {
  environmentTemplateId: Scalars['String']['input'];
  initDefaults?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  isDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type EnvironmentManagedService = {
  __typename?: 'EnvironmentManagedService';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  /** Reads a single `Environment` that is related to this `EnvironmentManagedService`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['UUID']['output'];
  isCoreService?: Maybe<Scalars['Boolean']['output']>;
  managedServiceId: Scalars['String']['output'];
  managedServiceName?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  state: EnvironmentServiceState;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * A condition to be used against `EnvironmentManagedService` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EnvironmentManagedServiceCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `managedServiceId` field. */
  managedServiceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<EnvironmentServiceState>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `EnvironmentManagedService` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentManagedServiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentManagedServiceFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environment` relation. */
  environment?: InputMaybe<EnvironmentFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isCoreService` field. */
  isCoreService?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `managedServiceId` field. */
  managedServiceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `managedServiceName` field. */
  managedServiceName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentManagedServiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentManagedServiceFilter>>;
  /** Filter by the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<EnvironmentServiceStateFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

export type EnvironmentManagedServiceLog = {
  __typename?: 'EnvironmentManagedServiceLog';
  createdAt: Scalars['Datetime']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  managedServiceId: Scalars['String']['output'];
  messageBody: Scalars['JSON']['output'];
  messageType: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `EnvironmentManagedServiceLog` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EnvironmentManagedServiceLogCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `managedServiceId` field. */
  managedServiceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `messageBody` field. */
  messageBody?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `messageType` field. */
  messageType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `EnvironmentManagedServiceLog` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentManagedServiceLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentManagedServiceLogFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `managedServiceId` field. */
  managedServiceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `messageBody` field. */
  messageBody?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `messageType` field. */
  messageType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentManagedServiceLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentManagedServiceLogFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `EnvironmentManagedServiceLog` values. */
export type EnvironmentManagedServiceLogsConnection = {
  __typename?: 'EnvironmentManagedServiceLogsConnection';
  /** A list of edges which contains the `EnvironmentManagedServiceLog` and cursor to aid in pagination. */
  edges: Array<EnvironmentManagedServiceLogsEdge>;
  /** A list of `EnvironmentManagedServiceLog` objects. */
  nodes: Array<EnvironmentManagedServiceLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EnvironmentManagedServiceLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EnvironmentManagedServiceLog` edge in the connection. */
export type EnvironmentManagedServiceLogsEdge = {
  __typename?: 'EnvironmentManagedServiceLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnvironmentManagedServiceLog` at the end of the edge. */
  node: EnvironmentManagedServiceLog;
};

/** Methods to use when ordering `EnvironmentManagedServiceLog`. */
export enum EnvironmentManagedServiceLogsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ManagedServiceIdAsc = 'MANAGED_SERVICE_ID_ASC',
  ManagedServiceIdDesc = 'MANAGED_SERVICE_ID_DESC',
  MessageBodyAsc = 'MESSAGE_BODY_ASC',
  MessageBodyDesc = 'MESSAGE_BODY_DESC',
  MessageTypeAsc = 'MESSAGE_TYPE_ASC',
  MessageTypeDesc = 'MESSAGE_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

export type EnvironmentManagedServiceStateChangedSubscriptionPayload = {
  __typename?: 'EnvironmentManagedServiceStateChangedSubscriptionPayload';
  environment?: Maybe<Environment>;
  eventKey?: Maybe<EnvironmentManagedServiceStateEventKey>;
  id: Scalars['UUID']['output'];
};

export enum EnvironmentManagedServiceStateEventKey {
  EnvironmentManagedServiceStateChanged = 'ENVIRONMENT_MANAGED_SERVICE_STATE_CHANGED',
  EnvironmentManagedServiceStateCreated = 'ENVIRONMENT_MANAGED_SERVICE_STATE_CREATED',
  EnvironmentManagedServiceStateDeleted = 'ENVIRONMENT_MANAGED_SERVICE_STATE_DELETED'
}

/** A connection to a list of `EnvironmentManagedService` values. */
export type EnvironmentManagedServicesConnection = {
  __typename?: 'EnvironmentManagedServicesConnection';
  /** A list of edges which contains the `EnvironmentManagedService` and cursor to aid in pagination. */
  edges: Array<EnvironmentManagedServicesEdge>;
  /** A list of `EnvironmentManagedService` objects. */
  nodes: Array<EnvironmentManagedService>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EnvironmentManagedService` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EnvironmentManagedService` edge in the connection. */
export type EnvironmentManagedServicesEdge = {
  __typename?: 'EnvironmentManagedServicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnvironmentManagedService` at the end of the edge. */
  node: EnvironmentManagedService;
};

/** Methods to use when ordering `EnvironmentManagedService`. */
export enum EnvironmentManagedServicesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  ManagedServiceIdAsc = 'MANAGED_SERVICE_ID_ASC',
  ManagedServiceIdDesc = 'MANAGED_SERVICE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

/** Represents an update to a `Environment`. Fields that are set will be updated. */
export type EnvironmentPatch = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orchestrationState?: InputMaybe<OrchestrationState>;
};

export enum EnvironmentServiceState {
  /** Disabled */
  Disabled = 'DISABLED',
  /** Disabling */
  Disabling = 'DISABLING',
  /** Enabled */
  Enabled = 'ENABLED',
  /** Enabling */
  Enabling = 'ENABLING',
  /** Error Disabling */
  ErrorDisabling = 'ERROR_DISABLING',
  /** Error Enabling */
  ErrorEnabling = 'ERROR_ENABLING'
}

/** A filter to be used against EnvironmentServiceState fields. All fields are combined with a logical ‘and.’ */
export type EnvironmentServiceStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EnvironmentServiceState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EnvironmentServiceState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EnvironmentServiceState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EnvironmentServiceState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EnvironmentServiceState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<EnvironmentServiceState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EnvironmentServiceState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EnvironmentServiceState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EnvironmentServiceState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EnvironmentServiceState>>;
};

export type EnvironmentTemplate = {
  __typename?: 'EnvironmentTemplate';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `EnvironmentTemplate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EnvironmentTemplateCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `EnvironmentTemplate` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentTemplateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentTemplateFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentTemplateFilter>>;
  /** Filter by the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<IntFilter>;
};

/** A connection to a list of `EnvironmentTemplate` values. */
export type EnvironmentTemplatesConnection = {
  __typename?: 'EnvironmentTemplatesConnection';
  /** A list of edges which contains the `EnvironmentTemplate` and cursor to aid in pagination. */
  edges: Array<EnvironmentTemplatesEdge>;
  /** A list of `EnvironmentTemplate` objects. */
  nodes: Array<EnvironmentTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EnvironmentTemplate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EnvironmentTemplate` edge in the connection. */
export type EnvironmentTemplatesEdge = {
  __typename?: 'EnvironmentTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnvironmentTemplate` at the end of the edge. */
  node: EnvironmentTemplate;
};

/** Methods to use when ordering `EnvironmentTemplate`. */
export enum EnvironmentTemplatesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

/** A filter to be used against many `EnvironmentManagedService` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentToManyEnvironmentManagedServiceFilter = {
  /** Every related `EnvironmentManagedService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EnvironmentManagedServiceFilter>;
  /** No related `EnvironmentManagedService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EnvironmentManagedServiceFilter>;
  /** Some related `EnvironmentManagedService` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EnvironmentManagedServiceFilter>;
};

/** A filter to be used against many `IdServiceConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentToManyIdServiceConfigurationFilter = {
  /** Every related `IdServiceConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IdServiceConfigurationFilter>;
  /** No related `IdServiceConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IdServiceConfigurationFilter>;
  /** Some related `IdServiceConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IdServiceConfigurationFilter>;
};

/** A filter to be used against many `IdpConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentToManyIdpConfigurationFilter = {
  /** Every related `IdpConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IdpConfigurationFilter>;
  /** No related `IdpConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IdpConfigurationFilter>;
  /** Some related `IdpConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IdpConfigurationFilter>;
};

/** A filter to be used against many `ServiceAccount` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentToManyServiceAccountFilter = {
  /** Every related `ServiceAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServiceAccountFilter>;
  /** No related `ServiceAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServiceAccountFilter>;
  /** Some related `ServiceAccount` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServiceAccountFilter>;
};

/** A filter to be used against many `ServiceAccountPermissionAssignment` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentToManyServiceAccountPermissionAssignmentFilter = {
  /** Every related `ServiceAccountPermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
  /** No related `ServiceAccountPermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
  /** Some related `ServiceAccountPermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
};

/** A connection to a list of `Environment` values. */
export type EnvironmentsConnection = {
  __typename?: 'EnvironmentsConnection';
  /** A list of edges which contains the `Environment` and cursor to aid in pagination. */
  edges: Array<EnvironmentsEdge>;
  /** A list of `Environment` objects. */
  nodes: Array<Environment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Environment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Environment` edge in the connection. */
export type EnvironmentsEdge = {
  __typename?: 'EnvironmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Environment` at the end of the edge. */
  node: Environment;
};

/** Methods to use when ordering `Environment`. */
export enum EnvironmentsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  EnvironmentTemplateIdAsc = 'ENVIRONMENT_TEMPLATE_ID_ASC',
  EnvironmentTemplateIdDesc = 'ENVIRONMENT_TEMPLATE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InitDefaultsAsc = 'INIT_DEFAULTS_ASC',
  InitDefaultsDesc = 'INIT_DEFAULTS_DESC',
  IsDevelopmentAsc = 'IS_DEVELOPMENT_ASC',
  IsDevelopmentDesc = 'IS_DEVELOPMENT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrchestrationErrorDetailsAsc = 'ORCHESTRATION_ERROR_DETAILS_ASC',
  OrchestrationErrorDetailsDesc = 'ORCHESTRATION_ERROR_DETAILS_DESC',
  OrchestrationStateAsc = 'ORCHESTRATION_STATE_ASC',
  OrchestrationStateDesc = 'ORCHESTRATION_STATE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

/** Exposes all error codes and messages for errors that a service requests can throw. In some cases, messages that are actually thrown can be different, since they can include more details or a single code can used for different errors of the same type. */
export enum ErrorCodesEnum {
  /** Access Token has expired. */
  AccessTokenExpired = 'ACCESS_TOKEN_EXPIRED',
  /** Access Token is invalid */
  AccessTokenInvalid = 'ACCESS_TOKEN_INVALID',
  /** Access Token Lifetime must be greater than or equal to 30. */
  AccessTokenLifetimeInsufficient = 'ACCESS_TOKEN_LIFETIME_INSUFFICIENT',
  /** Access Token is not provided */
  AccessTokenRequired = 'ACCESS_TOKEN_REQUIRED',
  /** Access token verification failed */
  AccessTokenVerificationFailed = 'ACCESS_TOKEN_VERIFICATION_FAILED',
  /** An active signing key already exists for the application. */
  ActiveSigningKeyExists = 'ACTIVE_SIGNING_KEY_EXISTS',
  /** The assertion check for the identifier %s failed. */
  AssertionFailed = 'ASSERTION_FAILED',
  /** Authenticated End User not found. */
  AuthenticatedEndUserNotFound = 'AUTHENTICATED_END_USER_NOT_FOUND',
  /** Authenticated Management Subject not found. */
  AuthenticatedManagementSubjectNotFound = 'AUTHENTICATED_MANAGEMENT_SUBJECT_NOT_FOUND',
  /** A Permission Definition or an EndUserAuthorizationConfig was not found to be passed into Postgraphile build options. This is a development time issue. */
  AuthorizationOptionsMisconfigured = 'AUTHORIZATION_OPTIONS_MISCONFIGURED',
  /** Auth config is invalid. */
  AuthConfigInvalid = 'AUTH_CONFIG_INVALID',
  /** Permission synchronization is allowed for Service IDs that start with `ax-` only with Managed Service Accounts. */
  AxServicePermissionSyncNotAllowed = 'AX_SERVICE_PERMISSION_SYNC_NOT_ALLOWED',
  /** Cannot change the state while the service [%s] has a pending state change. No action was performed. */
  CannotChangeStateWhenPending = 'CANNOT_CHANGE_STATE_WHEN_PENDING',
  /** Cannot change the state for the service [%s] when it has a failed state change attempt, please retry the previous action. No action was performed. */
  CannotChangeStateWithError = 'CANNOT_CHANGE_STATE_WITH_ERROR',
  /** Service [%s] is a core-service and cannot be disabled. No action was performed. */
  CannotDisableCoreService = 'CANNOT_DISABLE_CORE_SERVICE',
  /** Unable to enable Tenant as there are currently no Tenant Administrators in active state. */
  CannotEnableTenant = 'CANNOT_ENABLE_TENANT',
  /** Client ID and Client Secret are required to enable the identity provider. */
  ClientIdSecretRequired = 'CLIENT_ID_SECRET_REQUIRED',
  /** Error updating service account client secret. */
  ClientSecretUpdateFailed = 'CLIENT_SECRET_UPDATE_FAILED',
  /** The service [%s] does not support the [%s] command. */
  CommandNotSupported = 'COMMAND_NOT_SUPPORTED',
  /** Contains invalid permissions. */
  ContainsInvalidPermissions = 'CONTAINS_INVALID_PERMISSIONS',
  /** Custom branding is not allowed for this identity provider. */
  CustomBrandingNotAllowed = 'CUSTOM_BRANDING_NOT_ALLOWED',
  /** customStepFunctionName missing in orchestration step. */
  CustomStepFunctionNameMissing = 'CUSTOM_STEP_FUNCTION_NAME_MISSING',
  /** A database operation has failed because of a lock timeout. */
  DatabaseLockTimeoutError = 'DATABASE_LOCK_TIMEOUT_ERROR',
  /** An authorization database error has occurred. The user might not have enough permissions. */
  DatabasePermissionsCheckFailed = 'DATABASE_PERMISSIONS_CHECK_FAILED',
  /** An expected and handled database constraint error has occurred. The actual message will have more information. */
  DatabaseValidationFailed = 'DATABASE_VALIDATION_FAILED',
  /** Error accessing database. */
  DbAccessError = 'DB_ACCESS_ERROR',
  /** Environment [%s] is not enabled for use. */
  EnvironmentNotActive = 'ENVIRONMENT_NOT_ACTIVE',
  /** Environment [%s] not found. */
  EnvironmentNotFound = 'ENVIRONMENT_NOT_FOUND',
  /** The account is not activated. Please contact another Tenant Administrator or Axinom Support to activate the account. */
  EnvAdminAccountNotActive = 'ENV_ADMIN_ACCOUNT_NOT_ACTIVE',
  /** Either the account or the tenant is not enabled for usage. */
  EnvAdminOrTenantNotActive = 'ENV_ADMIN_OR_TENANT_NOT_ACTIVE',
  /** Cannot enable the environment when the initialization status is not [Completed]. */
  EnvInitializationNotCompleted = 'ENV_INITIALIZATION_NOT_COMPLETED',
  /** Error occurred generating a service account secret. */
  ErrorGeneratingServiceAccountSecret = 'ERROR_GENERATING_SERVICE_ACCOUNT_SECRET',
  /** An error occurred while attempting to retrieve token signing key details. */
  ErrorRetrievingSigningKeys = 'ERROR_RETRIEVING_SIGNING_KEYS',
  /** This is a wrapper error for the original unhandled error of unsupported type. */
  ErrorWrapper = 'ERROR_WRAPPER',
  /** A GraphQL validation error has occurred. Please make sure that the GraphQL request is made with correct syntax or parameters. */
  GraphqlValidationFailed = 'GRAPHQL_VALIDATION_FAILED',
  /** The Identity service is not accessible. Please contact Axinom support. */
  IdentityServiceNotAccessible = 'IDENTITY_SERVICE_NOT_ACCESSIBLE',
  /** IDP configuration does not exist. */
  IdpConfigDoesNotExist = 'IDP_CONFIG_DOES_NOT_EXIST',
  /** Built in IDP configuration is only available for Google IDP. */
  IdpConfigOnlyAvailableForGoogle = 'IDP_CONFIG_ONLY_AVAILABLE_FOR_GOOGLE',
  /** The value for initDefaults does not match its schema. */
  InitDefaultsSchemaMismatch = 'INIT_DEFAULTS_SCHEMA_MISMATCH',
  /** An unhandled and unexpected error has occurred. Please contact the service support. */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** Invalid Client ID or Client Secret */
  InvalidClientIdSecret = 'INVALID_CLIENT_ID_SECRET',
  /** Invalid email or password. */
  InvalidCredentials = 'INVALID_CREDENTIALS',
  /** Email format is invalid. */
  InvalidEmailFormat = 'INVALID_EMAIL_FORMAT',
  /** Invalid email or tenant not enabled for usage. */
  InvalidEmailOrTenantInactive = 'INVALID_EMAIL_OR_TENANT_INACTIVE',
  /** Email Whitelist Pattern is not valid */
  InvalidEmailWhitelistPattern = 'INVALID_EMAIL_WHITELIST_PATTERN',
  /** Invalid Environment ID. */
  InvalidEnvironmentId = 'INVALID_ENVIRONMENT_ID',
  /** Unrecognized state change was attempted and an error was logged. */
  InvalidEnvironmentState = 'INVALID_ENVIRONMENT_STATE',
  /** Error occurred while trying to fetch signing keys from the JWKS endpoint for the Tenant/Environment/Application. */
  JwksError = 'JWKS_ERROR',
  /** Passed JWT is not a Mosaic End-User Token. Cannot be verified. */
  JwtIsNotMosaicToken = 'JWT_IS_NOT_MOSAIC_TOKEN',
  /** Please disable the tenant before deactivating the last active Tenant Administrator. */
  LastTenantAdminActiveTenantDeactivate = 'LAST_TENANT_ADMIN_ACTIVE_TENANT_DEACTIVATE',
  /** Please disable the tenant before deleting the last active Tenant Administrator. */
  LastTenantAdminActiveTenantDelete = 'LAST_TENANT_ADMIN_ACTIVE_TENANT_DELETE',
  /** IDP logout can only be enabled for custom identity providers. */
  LogoutFromIdpNotAllowed = 'LOGOUT_FROM_IDP_NOT_ALLOWED',
  /** Malformed access token received */
  MalformedToken = 'MALFORMED_TOKEN',
  /** Service [%s] is already disabled for this environment. No action was performed. */
  ManagedServiceAlreadyDisabled = 'MANAGED_SERVICE_ALREADY_DISABLED',
  /** Service [%s] is already enabled for this environment. No action was performed. */
  ManagedServiceAlreadyEnabled = 'MANAGED_SERVICE_ALREADY_ENABLED',
  /** Managed service [%s] not found in environment [%s]. */
  ManagedServiceNotFound = 'MANAGED_SERVICE_NOT_FOUND',
  /** The token is not an Authenticated End-User */
  NotAuthenticatedEndUser = 'NOT_AUTHENTICATED_END_USER',
  /** The object is not a AuthenticatedManagementSubject */
  NotAuthenticatedManagementSubject = 'NOT_AUTHENTICATED_MANAGEMENT_SUBJECT',
  /** The object is not a AuthenticatedRequest */
  NotAuthenticatedRequest = 'NOT_AUTHENTICATED_REQUEST',
  /** A caught error is not an AxiosError. */
  NotAxiosError = 'NOT_AXIOS_ERROR',
  /** The token is not an End-User Application */
  NotEndUserApplication = 'NOT_END_USER_APPLICATION',
  /** The object is not an EndUserAuthenticationContext */
  NotEndUserAuthenticationContext = 'NOT_END_USER_AUTHENTICATION_CONTEXT',
  /** The object is not a GenericAuthenticatedSubject */
  NotGenericAuthenticatedSubject = 'NOT_GENERIC_AUTHENTICATED_SUBJECT',
  /** The object is not a ManagementAuthenticationContext */
  NotManagementAuthenticationContext = 'NOT_MANAGEMENT_AUTHENTICATION_CONTEXT',
  /** No active token signing keys found for the environment [%s]. */
  NoActiveSigningKey = 'NO_ACTIVE_SIGNING_KEY',
  /** Token does not contain an email. */
  NoEmailInToken = 'NO_EMAIL_IN_TOKEN',
  /** A caught error does not contain an error code. */
  NoErrorCodeFound = 'NO_ERROR_CODE_FOUND',
  /** The %s is missing required properties: %s. */
  ObjectIsMissingProperties = 'OBJECT_IS_MISSING_PROPERTIES',
  /** The user [%s] can only use Single Sign-On mode for tenant [%s]. */
  OnlySsoAllowed = 'ONLY_SSO_ALLOWED',
  /** The environment's first orchestration step must have message-params. */
  OrchestrationParamsMissing = 'ORCHESTRATION_PARAMS_MISSING',
  /** Dynamic orchestration step resolution failed. */
  OrchestrationStepResolutionFailed = 'ORCHESTRATION_STEP_RESOLUTION_FAILED',
  /** Error generating the password. */
  PasswordGeneartionError = 'PASSWORD_GENEARTION_ERROR',
  /** The new password does not meet the minimum policy requirements. */
  PasswordPolicyMismatch = 'PASSWORD_POLICY_MISMATCH',
  /** Payload not found in pg-notification. */
  PayloadNotFound = 'PAYLOAD_NOT_FOUND',
  /** Error occurred trying to purge permissions. */
  PermissionPurgeError = 'PERMISSION_PURGE_ERROR',
  /** Purging permissions for Service IDs that start with `ax-` is not allowed. */
  PermissionPurgeNotAllowedForAxServices = 'PERMISSION_PURGE_NOT_ALLOWED_FOR_AX_SERVICES',
  /** Error occurred trying to synchronize permissions. */
  PermissionSyncError = 'PERMISSION_SYNC_ERROR',
  /** Root Tenant not found. */
  RootTenantNotFound = 'ROOT_TENANT_NOT_FOUND',
  /** An error occurred while exporting Service Accounts. */
  ServiceAccountExportError = 'SERVICE_ACCOUNT_EXPORT_ERROR',
  /** An error occurred while importing Service Accounts. */
  ServiceAccountImportError = 'SERVICE_ACCOUNT_IMPORT_ERROR',
  /** Service Account does not exist. */
  ServiceAccountNotExists = 'SERVICE_ACCOUNT_NOT_EXISTS',
  /** This service account is protected and cannot be modified or deleted. Remove the protection first. */
  ServiceAccountProtected = 'SERVICE_ACCOUNT_PROTECTED',
  /** The service-id is required for service-state-change-events. */
  ServiceIdNotFound = 'SERVICE_ID_NOT_FOUND',
  /** Could not find a matching signing key to verify the access token. The signing key used to create the token may have been revoked or the Tenant/Environment/Application configuration is erroneous. */
  SigningKeyNotFound = 'SIGNING_KEY_NOT_FOUND',
  /** An error occurred while rotating signing keys. */
  SigningKeyRotateError = 'SIGNING_KEY_ROTATE_ERROR',
  /** We encountered an error while validating your SSO token with the Axinom Portal. Please try again in a few seconds. If the problem persists, please contact Axinom Support. */
  SsoTokenValidationError = 'SSO_TOKEN_VALIDATION_ERROR',
  /** An application startup error has occurred. The actual message will have more information. */
  StartupError = 'STARTUP_ERROR',
  /** Step function [%s] is not found in the mapping. */
  StepFunctionNotFoundInMapping = 'STEP_FUNCTION_NOT_FOUND_IN_MAPPING',
  /** Orchestration error. Step function [%s] not found. */
  StepFuncNotFound = 'STEP_FUNC_NOT_FOUND',
  /** User is authenticated, but subject information was not found. Please contact Axinom Support. */
  SubjectNotFound = 'SUBJECT_NOT_FOUND',
  /** Could not complete authentication. targetTenantId is missing. */
  TargetTenantMissing = 'TARGET_TENANT_MISSING',
  /** The linked Environment Administration Portal account [%s] is not active. Please contact Axinom Support. */
  TenantAdminNotActive = 'TENANT_ADMIN_NOT_ACTIVE',
  /** Tenant Admin does not exist. */
  TenantAdminNotExists = 'TENANT_ADMIN_NOT_EXISTS',
  /** Tenant Admin [%s] not found. */
  TenantAdminNotFound = 'TENANT_ADMIN_NOT_FOUND',
  /** The Environment Administration Portal is not linked to your Axinom Portal account [%s]. Please contact Axinom Support. */
  TenantAdminNotLinkedToAxPortal = 'TENANT_ADMIN_NOT_LINKED_TO_AX_PORTAL',
  /** The tenant [%s] is not active. Please contact Axinom Support. */
  TenantNotActive = 'TENANT_NOT_ACTIVE',
  /** Tenant does not exist. */
  TenantNotExists = 'TENANT_NOT_EXISTS',
  /** Tenant [%s] not found. */
  TenantNotFound = 'TENANT_NOT_FOUND',
  /** The subject has no permissions. */
  Unauthorized = 'UNAUTHORIZED',
  /** Unexpected null or undefined value received. */
  UnexpectedNullUndefined = 'UNEXPECTED_NULL_UNDEFINED',
  /** Unhandled Axios error. */
  UnhandledAxiosError = 'UNHANDLED_AXIOS_ERROR',
  /** An unhandled database-related error has occurred. Please contact the service support. */
  UnhandledDatabaseError = 'UNHANDLED_DATABASE_ERROR',
  /** An unhandled error has occurred. Please contact the service support. */
  UnhandledError = 'UNHANDLED_ERROR',
  /** Attempt to create or update an element failed, as it would have resulted in a duplicate element. */
  UniqueConstraintError = 'UNIQUE_CONSTRAINT_ERROR',
  /** Environment created with an unsupported template [%s]. */
  UnsupportedTemplate = 'UNSUPPORTED_TEMPLATE',
  /** User is not authorized to access the operation. */
  UserNotAuthorized = 'USER_NOT_AUTHORIZED',
  /** The User service is not accessible. Please contact Axinom support. */
  UserServiceNotAccessible = 'USER_SERVICE_NOT_ACCESSIBLE',
  /** The %s is not an object. */
  ValueIsNotObject = 'VALUE_IS_NOT_OBJECT',
  /** Websocket not found in ExtendedGraphQLContext. This is a development time issue. A reference to the websocket must be included in Postgraphile build options. */
  WebsocketNotFound = 'WEBSOCKET_NOT_FOUND'
}

export type ExchangeAccessTokenInput = {
  environmentId: Scalars['UUID']['input'];
};

export type ExchangeAccessTokenPayload = {
  __typename?: 'ExchangeAccessTokenPayload';
  /** New access token containing environment ID */
  accessToken: Scalars['String']['output'];
  /** Access Token expiration timeout */
  expiresInSeconds: Scalars['Int']['output'];
  /** Access Token type to use when making client requests */
  tokenType: Scalars['String']['output'];
};

export type ExportedPermissionRef = {
  __typename?: 'ExportedPermissionRef';
  name: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
};

export type ExportedServiceAccount = {
  __typename?: 'ExportedServiceAccount';
  isProtected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<ExportedPermissionRef>;
};

export type GenerateServiceAccountSecretInput = {
  id: Scalars['String']['input'];
};

export type GenerateServiceAccountSecretPayload = {
  __typename?: 'GenerateServiceAccountSecretPayload';
  /** Generated client secret. */
  clientSecret: Scalars['String']['output'];
  serviceAccount?: Maybe<ServiceAccount>;
};

export type GetTenantsBySsoTokenInput = {
  ssoToken: Scalars['String']['input'];
};

export type GetTenantsBySsoTokenPayload = {
  __typename?: 'GetTenantsBySSOTokenPayload';
  tenantAdminName?: Maybe<Scalars['String']['output']>;
  tenants?: Maybe<Array<Maybe<TenantForSsoToken>>>;
};

export type IdServiceConfiguration = {
  __typename?: 'IdServiceConfiguration';
  accessTokenLifetime: Scalars['Int']['output'];
  allowedOrigins?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cookieLifetime: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  /** Reads a single `Environment` that is related to this `IdServiceConfiguration`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  managementSuperAdmins?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  serviceAccountTokenLifetime: Scalars['Int']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  workflowsEnabled: Scalars['Boolean']['output'];
};

/**
 * A condition to be used against `IdServiceConfiguration` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type IdServiceConfigurationCondition = {
  /** Checks for equality with the object’s `accessTokenLifetime` field. */
  accessTokenLifetime?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `allowedOrigins` field. */
  allowedOrigins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `cookieLifetime` field. */
  cookieLifetime?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `managementSuperAdmins` field. */
  managementSuperAdmins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `serviceAccountTokenLifetime` field. */
  serviceAccountTokenLifetime?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `workflowsEnabled` field. */
  workflowsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `IdServiceConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type IdServiceConfigurationFilter = {
  /** Filter by the object’s `accessTokenLifetime` field. */
  accessTokenLifetime?: InputMaybe<IntFilter>;
  /** Filter by the object’s `allowedOrigins` field. */
  allowedOrigins?: InputMaybe<StringListFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IdServiceConfigurationFilter>>;
  /** Filter by the object’s `cookieLifetime` field. */
  cookieLifetime?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environment` relation. */
  environment?: InputMaybe<EnvironmentFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `managementSuperAdmins` field. */
  managementSuperAdmins?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IdServiceConfigurationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IdServiceConfigurationFilter>>;
  /** Filter by the object’s `serviceAccountTokenLifetime` field. */
  serviceAccountTokenLifetime?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `workflowsEnabled` field. */
  workflowsEnabled?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `IdServiceConfiguration` */
export type IdServiceConfigurationInput = {
  accessTokenLifetime?: InputMaybe<Scalars['Int']['input']>;
  allowedOrigins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cookieLifetime?: InputMaybe<Scalars['Int']['input']>;
  environmentId: Scalars['UUID']['input'];
  managementSuperAdmins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serviceAccountTokenLifetime?: InputMaybe<Scalars['Int']['input']>;
  workflowsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `IdServiceConfiguration`. Fields that are set will be updated. */
export type IdServiceConfigurationPatch = {
  accessTokenLifetime?: InputMaybe<Scalars['Int']['input']>;
  allowedOrigins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cookieLifetime?: InputMaybe<Scalars['Int']['input']>;
  managementSuperAdmins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serviceAccountTokenLifetime?: InputMaybe<Scalars['Int']['input']>;
  workflowsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `IdServiceConfiguration` values. */
export type IdServiceConfigurationsConnection = {
  __typename?: 'IdServiceConfigurationsConnection';
  /** A list of edges which contains the `IdServiceConfiguration` and cursor to aid in pagination. */
  edges: Array<IdServiceConfigurationsEdge>;
  /** A list of `IdServiceConfiguration` objects. */
  nodes: Array<IdServiceConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IdServiceConfiguration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IdServiceConfiguration` edge in the connection. */
export type IdServiceConfigurationsEdge = {
  __typename?: 'IdServiceConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IdServiceConfiguration` at the end of the edge. */
  node: IdServiceConfiguration;
};

/** Methods to use when ordering `IdServiceConfiguration`. */
export enum IdServiceConfigurationsOrderBy {
  AccessTokenLifetimeAsc = 'ACCESS_TOKEN_LIFETIME_ASC',
  AccessTokenLifetimeDesc = 'ACCESS_TOKEN_LIFETIME_DESC',
  AllowedOriginsAsc = 'ALLOWED_ORIGINS_ASC',
  AllowedOriginsDesc = 'ALLOWED_ORIGINS_DESC',
  CookieLifetimeAsc = 'COOKIE_LIFETIME_ASC',
  CookieLifetimeDesc = 'COOKIE_LIFETIME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ManagementSuperAdminsAsc = 'MANAGEMENT_SUPER_ADMINS_ASC',
  ManagementSuperAdminsDesc = 'MANAGEMENT_SUPER_ADMINS_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ServiceAccountTokenLifetimeAsc = 'SERVICE_ACCOUNT_TOKEN_LIFETIME_ASC',
  ServiceAccountTokenLifetimeDesc = 'SERVICE_ACCOUNT_TOKEN_LIFETIME_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  WorkflowsEnabledAsc = 'WORKFLOWS_ENABLED_ASC',
  WorkflowsEnabledDesc = 'WORKFLOWS_ENABLED_DESC'
}

export enum IdentityProvider {
  /** Axinom */
  Axinom = 'AXINOM',
  /** AxAuth */
  AxAuth = 'AX_AUTH',
  /** Azure AD */
  AzureAd = 'AZURE_AD',
  /** Custom */
  Custom = 'CUSTOM',
  /** Google */
  Google = 'GOOGLE'
}

/** A filter to be used against IdentityProvider fields. All fields are combined with a logical ‘and.’ */
export type IdentityProviderFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IdentityProvider>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IdentityProvider>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IdentityProvider>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IdentityProvider>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IdentityProvider>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IdentityProvider>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IdentityProvider>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IdentityProvider>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IdentityProvider>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IdentityProvider>>;
};

export type IdpConfiguration = {
  __typename?: 'IdpConfiguration';
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecretIsSet: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  discoveryDocumentUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** Reads a single `Environment` that is related to this `IdpConfiguration`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  idpId: IdentityProvider;
  idpImageUrl?: Maybe<Scalars['String']['output']>;
  logoutFromIdp: Scalars['Boolean']['output'];
  scopes: Array<Maybe<Scalars['String']['output']>>;
  sortOrder: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  useBuiltInIdp?: Maybe<Scalars['Boolean']['output']>;
  useCustomBranding: Scalars['Boolean']['output'];
};

/**
 * A condition to be used against `IdpConfiguration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IdpConfigurationCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `clientSecret` field. */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `discoveryDocumentUrl` field. */
  discoveryDocumentUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `enabled` field. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `idpId` field. */
  idpId?: InputMaybe<IdentityProvider>;
  /** Checks for equality with the object’s `idpImageUrl` field. */
  idpImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `logoutFromIdp` field. */
  logoutFromIdp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `scopes` field. */
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `useCustomBranding` field. */
  useCustomBranding?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `IdpConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type IdpConfigurationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IdpConfigurationFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `clientSecret` field. */
  clientSecret?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `discoveryDocumentUrl` field. */
  discoveryDocumentUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `enabled` field. */
  enabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `environment` relation. */
  environment?: InputMaybe<EnvironmentFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `idpId` field. */
  idpId?: InputMaybe<IdentityProviderFilter>;
  /** Filter by the object’s `idpImageUrl` field. */
  idpImageUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logoutFromIdp` field. */
  logoutFromIdp?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IdpConfigurationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IdpConfigurationFilter>>;
  /** Filter by the object’s `scopes` field. */
  scopes?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `useCustomBranding` field. */
  useCustomBranding?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `IdpConfiguration` */
export type IdpConfigurationInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  discoveryDocumentUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environmentId: Scalars['UUID']['input'];
  idpId: IdentityProvider;
  idpImageUrl?: InputMaybe<Scalars['String']['input']>;
  logoutFromIdp?: InputMaybe<Scalars['Boolean']['input']>;
  scopes: Array<InputMaybe<Scalars['String']['input']>>;
  sortOrder: Scalars['Int']['input'];
  useBuiltInIdp?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomBranding?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `IdpConfiguration`. Fields that are set will be updated. */
export type IdpConfigurationPatch = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  discoveryDocumentUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  idpImageUrl?: InputMaybe<Scalars['String']['input']>;
  logoutFromIdp?: InputMaybe<Scalars['Boolean']['input']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  useBuiltInIdp?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomBranding?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `IdpConfiguration` values. */
export type IdpConfigurationsConnection = {
  __typename?: 'IdpConfigurationsConnection';
  /** A list of edges which contains the `IdpConfiguration` and cursor to aid in pagination. */
  edges: Array<IdpConfigurationsEdge>;
  /** A list of `IdpConfiguration` objects. */
  nodes: Array<IdpConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IdpConfiguration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IdpConfiguration` edge in the connection. */
export type IdpConfigurationsEdge = {
  __typename?: 'IdpConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IdpConfiguration` at the end of the edge. */
  node: IdpConfiguration;
};

/** Methods to use when ordering `IdpConfiguration`. */
export enum IdpConfigurationsOrderBy {
  ClientIdAsc = 'CLIENT_ID_ASC',
  ClientIdDesc = 'CLIENT_ID_DESC',
  ClientSecretAsc = 'CLIENT_SECRET_ASC',
  ClientSecretDesc = 'CLIENT_SECRET_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DiscoveryDocumentUrlAsc = 'DISCOVERY_DOCUMENT_URL_ASC',
  DiscoveryDocumentUrlDesc = 'DISCOVERY_DOCUMENT_URL_DESC',
  DisplayNameAsc = 'DISPLAY_NAME_ASC',
  DisplayNameDesc = 'DISPLAY_NAME_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdpIdAsc = 'IDP_ID_ASC',
  IdpIdDesc = 'IDP_ID_DESC',
  IdpImageUrlAsc = 'IDP_IMAGE_URL_ASC',
  IdpImageUrlDesc = 'IDP_IMAGE_URL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LogoutFromIdpAsc = 'LOGOUT_FROM_IDP_ASC',
  LogoutFromIdpDesc = 'LOGOUT_FROM_IDP_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScopesAsc = 'SCOPES_ASC',
  ScopesDesc = 'SCOPES_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UseCustomBrandingAsc = 'USE_CUSTOM_BRANDING_ASC',
  UseCustomBrandingDesc = 'USE_CUSTOM_BRANDING_DESC'
}

export type IdpScope = {
  __typename?: 'IdpScope';
  id: Scalars['UUID']['output'];
  idpId: IdentityProvider;
  required: Scalars['Boolean']['output'];
  scopeName: Scalars['String']['output'];
};

/**
 * A condition to be used against `IdpScope` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type IdpScopeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `idpId` field. */
  idpId?: InputMaybe<IdentityProvider>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `scopeName` field. */
  scopeName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `IdpScope` object types. All fields are combined with a logical ‘and.’ */
export type IdpScopeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IdpScopeFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `idpId` field. */
  idpId?: InputMaybe<IdentityProviderFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IdpScopeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IdpScopeFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `scopeName` field. */
  scopeName?: InputMaybe<StringFilter>;
};

/** A connection to a list of `IdpScope` values. */
export type IdpScopesConnection = {
  __typename?: 'IdpScopesConnection';
  /** A list of edges which contains the `IdpScope` and cursor to aid in pagination. */
  edges: Array<IdpScopesEdge>;
  /** A list of `IdpScope` objects. */
  nodes: Array<IdpScope>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IdpScope` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IdpScope` edge in the connection. */
export type IdpScopesEdge = {
  __typename?: 'IdpScopesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IdpScope` at the end of the edge. */
  node: IdpScope;
};

/** Methods to use when ordering `IdpScope`. */
export enum IdpScopesOrderBy {
  IdpIdAsc = 'IDP_ID_ASC',
  IdpIdDesc = 'IDP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RequiredAsc = 'REQUIRED_ASC',
  RequiredDesc = 'REQUIRED_DESC',
  ScopeNameAsc = 'SCOPE_NAME_ASC',
  ScopeNameDesc = 'SCOPE_NAME_DESC'
}

export type ImportEntityResult = {
  __typename?: 'ImportEntityResult';
  created: Array<Scalars['String']['output']>;
  skipped: Array<Scalars['String']['output']>;
  updated: Array<Scalars['String']['output']>;
};

export type ImportError = {
  __typename?: 'ImportError';
  detail?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  errorCode: ImportErrorCode;
};

export enum ImportErrorCode {
  InvalidPayload = 'INVALID_PAYLOAD',
  PayloadTooLarge = 'PAYLOAD_TOO_LARGE',
  PermissionNotFound = 'PERMISSION_NOT_FOUND'
}

export type ImportPermissionRefInput = {
  name: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type ImportServiceAccountInput = {
  isProtected?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<ImportPermissionRefInput>>;
};

export type ImportServiceAccountsInput = {
  serviceAccounts: Array<ImportServiceAccountInput>;
  version: Scalars['String']['input'];
};

export type ImportServiceAccountsPayload = {
  __typename?: 'ImportServiceAccountsPayload';
  errors: Array<ImportError>;
  serviceAccounts?: Maybe<ImportEntityResult>;
};

/** A filter to be used against InitDefaultsObject fields. All fields are combined with a logical ‘and.’ */
export type InitDefaultsObjectFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['InitDefaultsObject']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['InitDefaultsObject']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['InitDefaultsObject']['input']>>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Authenticates a Identity Service Tenant Admin */
  authenticateTenantAdmin: AuthenticateTenantAdminPayload;
  /** Authenticates a Identity Service Tenant Admin using the SSO Token */
  authenticateWithSSOToken?: Maybe<AuthenticateTenantAdminPayload>;
  /** Change the state of a managed-service for an environment */
  changeManagedServiceState: ChangeServiceStatePayload;
  /** Change password of a Identity Service Tenant Admin */
  changeTenantAdminPassword: AuthenticateTenantAdminPayload;
  /** Creates a single `EmailWhitelistPattern`. */
  createEmailWhitelistPattern?: Maybe<CreateEmailWhitelistPatternPayload>;
  /** Creates a single `EmailWhitelistPatternRole`. */
  createEmailWhitelistPatternRole?: Maybe<CreateEmailWhitelistPatternRolePayload>;
  /** Creates a single `Environment`. */
  createEnvironment?: Maybe<CreateEnvironmentPayload>;
  /** Creates a single `IdServiceConfiguration`. */
  createIdServiceConfiguration?: Maybe<CreateIdServiceConfigurationPayload>;
  /** Creates a single `IdpConfiguration`. */
  createIdpConfiguration?: Maybe<CreateIdpConfigurationPayload>;
  /** Creates a single `ServiceAccount`. */
  createServiceAccount?: Maybe<CreateServiceAccountPayload>;
  /** Creates a single `ServiceAccountPermissionAssignment`. */
  createServiceAccountPermissionAssignment?: Maybe<CreateServiceAccountPermissionAssignmentPayload>;
  createTenantAdmin?: Maybe<CreateTenantAdminPayload>;
  /** Deletes a single `EmailWhitelistPattern` using a unique key. */
  deleteEmailWhitelistPattern?: Maybe<DeleteEmailWhitelistPatternPayload>;
  /** Deletes a single `EmailWhitelistPatternRole` using a unique key. */
  deleteEmailWhitelistPatternRole?: Maybe<DeleteEmailWhitelistPatternRolePayload>;
  /** Deletes a single `Environment` using a unique key. */
  deleteEnvironment?: Maybe<DeleteEnvironmentPayload>;
  /** Deletes a single `IdpConfiguration` using a unique key. */
  deleteIdpConfiguration?: Maybe<DeleteIdpConfigurationPayload>;
  /** Deletes a single `ServiceAccount` using a unique key. */
  deleteServiceAccount?: Maybe<DeleteServiceAccountPayload>;
  /** Deletes a single `ServiceAccount` using a unique key. */
  deleteServiceAccountByClientId?: Maybe<DeleteServiceAccountPayload>;
  /** Deletes a single `ServiceAccountPermissionAssignment` using a unique key. */
  deleteServiceAccountPermissionAssignment?: Maybe<DeleteServiceAccountPermissionAssignmentPayload>;
  /** Deletes a single `TenantAdmin` using a unique key. */
  deleteTenantAdmin?: Maybe<DeleteTenantAdminPayload>;
  /** Create a new client registration */
  exchangeAccessToken: ExchangeAccessTokenPayload;
  /**
   * Exports Service Accounts matching the given condition/filter, including
   * their permissions.
   */
  exportServiceAccounts: ServiceAccountsExportPayload;
  /** Generates a new client secret for a `ServiceAccount`. */
  generateServiceAccountSecret?: Maybe<GenerateServiceAccountSecretPayload>;
  /**
   * Imports Service Accounts previously exported by
   * `exportServiceAccounts`, into the given environment.
   */
  importServiceAccounts: ImportServiceAccountsPayload;
  /** Generates a new password for a `TenantAdmin`. */
  resetTenantAdminPassword?: Maybe<ResetTenantAdminPasswordPayload>;
  /** Adds a custom mutation to revoke and rotate token signing keys */
  revokeAndRotateSigningKey: RevokeAndRotateSigningKeyPayload;
  /** Protects or unprotects a `ServiceAccount` by adding/removing its row in the protected service account registry. */
  setServiceAccountProtection: ServiceAccount;
  /** Updates a single `EmailWhitelistPattern` using a unique key and a patch. */
  updateEmailWhitelistPattern?: Maybe<UpdateEmailWhitelistPatternPayload>;
  /** Updates a single `EmailWhitelistPatternRole` using a unique key and a patch. */
  updateEmailWhitelistPatternRole?: Maybe<UpdateEmailWhitelistPatternRolePayload>;
  /** Updates a single `Environment` using a unique key and a patch. */
  updateEnvironment?: Maybe<UpdateEnvironmentPayload>;
  /** Updates a single `IdServiceConfiguration` using a unique key and a patch. */
  updateIdServiceConfiguration?: Maybe<UpdateIdServiceConfigurationPayload>;
  /** Updates a single `IdServiceConfiguration` using a unique key and a patch. */
  updateIdServiceConfigurationByEnvironmentId?: Maybe<UpdateIdServiceConfigurationPayload>;
  /** Updates a single `IdpConfiguration` using a unique key and a patch. */
  updateIdpConfiguration?: Maybe<UpdateIdpConfigurationPayload>;
  /** Updates a single `ServiceAccount` using a unique key and a patch. */
  updateServiceAccount?: Maybe<UpdateServiceAccountPayload>;
  /** Updates a single `ServiceAccount` using a unique key and a patch. */
  updateServiceAccountByClientId?: Maybe<UpdateServiceAccountPayload>;
  /** Updates a single `TenantAdmin` using a unique key and a patch. */
  updateTenantAdmin?: Maybe<UpdateTenantAdminPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAuthenticateTenantAdminArgs = {
  input?: InputMaybe<AuthenticateTenantAdminInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAuthenticateWithSsoTokenArgs = {
  input?: InputMaybe<AuthenticateWithSsoTokenInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeManagedServiceStateArgs = {
  input: ChangeServiceStateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeTenantAdminPasswordArgs = {
  input?: InputMaybe<ChangeTenantAdminPasswordInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmailWhitelistPatternArgs = {
  input: CreateEmailWhitelistPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmailWhitelistPatternRoleArgs = {
  input: CreateEmailWhitelistPatternRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEnvironmentArgs = {
  input: CreateEnvironmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIdServiceConfigurationArgs = {
  input: CreateIdServiceConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIdpConfigurationArgs = {
  input: CreateIdpConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateServiceAccountArgs = {
  input: CreateServiceAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateServiceAccountPermissionAssignmentArgs = {
  input: CreateServiceAccountPermissionAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantAdminArgs = {
  input: CreateTenantAdminInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailWhitelistPatternArgs = {
  input: DeleteEmailWhitelistPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailWhitelistPatternRoleArgs = {
  input: DeleteEmailWhitelistPatternRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEnvironmentArgs = {
  input: DeleteEnvironmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIdpConfigurationArgs = {
  input: DeleteIdpConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServiceAccountArgs = {
  input: DeleteServiceAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServiceAccountByClientIdArgs = {
  input: DeleteServiceAccountByClientIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServiceAccountPermissionAssignmentArgs = {
  input: DeleteServiceAccountPermissionAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantAdminArgs = {
  input: DeleteTenantAdminInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationExchangeAccessTokenArgs = {
  input?: InputMaybe<ExchangeAccessTokenInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationExportServiceAccountsArgs = {
  condition?: InputMaybe<ServiceAccountCondition>;
  filter?: InputMaybe<ServiceAccountFilter>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateServiceAccountSecretArgs = {
  input: GenerateServiceAccountSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationImportServiceAccountsArgs = {
  conflictResolution: ConflictResolution;
  environmentId: Scalars['UUID']['input'];
  input: ImportServiceAccountsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetTenantAdminPasswordArgs = {
  input: ResetTenantAdminPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeAndRotateSigningKeyArgs = {
  environmentId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetServiceAccountProtectionArgs = {
  input: SetServiceAccountProtectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailWhitelistPatternArgs = {
  input: UpdateEmailWhitelistPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailWhitelistPatternRoleArgs = {
  input: UpdateEmailWhitelistPatternRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEnvironmentArgs = {
  input: UpdateEnvironmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIdServiceConfigurationArgs = {
  input: UpdateIdServiceConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIdServiceConfigurationByEnvironmentIdArgs = {
  input: UpdateIdServiceConfigurationByEnvironmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIdpConfigurationArgs = {
  input: UpdateIdpConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateServiceAccountArgs = {
  input: UpdateServiceAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateServiceAccountByClientIdArgs = {
  input: UpdateServiceAccountByClientIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantAdminArgs = {
  input: UpdateTenantAdminInput;
};

export enum OrchestrationState {
  /** Completed */
  Completed = 'COMPLETED',
  /** Error */
  Error = 'ERROR',
  /** In progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING'
}

/** A filter to be used against OrchestrationState fields. All fields are combined with a logical ‘and.’ */
export type OrchestrationStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OrchestrationState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OrchestrationState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OrchestrationState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OrchestrationState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OrchestrationState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OrchestrationState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OrchestrationState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OrchestrationState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OrchestrationState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OrchestrationState>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  auditLog?: Maybe<AuditLog>;
  /** Reads and enables pagination through a set of `AuditLog`. */
  auditLogs?: Maybe<AuditLogsConnection>;
  emailWhitelistPattern?: Maybe<EmailWhitelistPattern>;
  emailWhitelistPatternRole?: Maybe<EmailWhitelistPatternRole>;
  /** Reads and enables pagination through a set of `EmailWhitelistPatternRole`. */
  emailWhitelistPatternRoles?: Maybe<EmailWhitelistPatternRolesConnection>;
  /** Reads and enables pagination through a set of `EmailWhitelistPattern`. */
  emailWhitelistPatterns?: Maybe<EmailWhitelistPatternsConnection>;
  environment?: Maybe<Environment>;
  environmentManagedService?: Maybe<EnvironmentManagedService>;
  environmentManagedServiceLog?: Maybe<EnvironmentManagedServiceLog>;
  /** Reads and enables pagination through a set of `EnvironmentManagedServiceLog`. */
  environmentManagedServiceLogs?: Maybe<EnvironmentManagedServiceLogsConnection>;
  /** Reads and enables pagination through a set of `EnvironmentManagedService`. */
  environmentManagedServices?: Maybe<EnvironmentManagedServicesConnection>;
  /** Reads and enables pagination through a set of `EnvironmentTemplate`. */
  environmentTemplates?: Maybe<EnvironmentTemplatesConnection>;
  /** Reads and enables pagination through a set of `Environment`. */
  environments?: Maybe<EnvironmentsConnection>;
  /** Get a list of tenants by SSO Token */
  getTenantsBySSOToken?: Maybe<GetTenantsBySsoTokenPayload>;
  idServiceConfiguration?: Maybe<IdServiceConfiguration>;
  idServiceConfigurationByEnvironmentId?: Maybe<IdServiceConfiguration>;
  /** Reads and enables pagination through a set of `IdServiceConfiguration`. */
  idServiceConfigurations?: Maybe<IdServiceConfigurationsConnection>;
  idpConfiguration?: Maybe<IdpConfiguration>;
  /** Reads and enables pagination through a set of `IdpConfiguration`. */
  idpConfigurations?: Maybe<IdpConfigurationsConnection>;
  idpScope?: Maybe<IdpScope>;
  /** Reads and enables pagination through a set of `IdpScope`. */
  idpScopes?: Maybe<IdpScopesConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  serviceAccount?: Maybe<ServiceAccount>;
  serviceAccountByClientId?: Maybe<ServiceAccount>;
  serviceAccountPermissionAssignment?: Maybe<ServiceAccountPermissionAssignment>;
  /** Reads and enables pagination through a set of `ServiceAccountPermissionAssignment`. */
  serviceAccountPermissionAssignments?: Maybe<ServiceAccountPermissionAssignmentsConnection>;
  /** Reads and enables pagination through a set of `ServiceAccount`. */
  serviceAccounts?: Maybe<ServiceAccountsConnection>;
  tenantAdmin?: Maybe<TenantAdmin>;
  /** Reads and enables pagination through a set of `TenantAdmin`. */
  tenantAdmins?: Maybe<TenantAdminsConnection>;
  /** Adds a custom query for token signing keys */
  tokenSigningKey: TokenSigningKeyPayload;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuditLogArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuditLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuditLogCondition>;
  filter?: InputMaybe<AuditLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailWhitelistPatternArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailWhitelistPatternRoleArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailWhitelistPatternRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailWhitelistPatternRoleCondition>;
  filter?: InputMaybe<EmailWhitelistPatternRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailWhitelistPatternRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailWhitelistPatternsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailWhitelistPatternCondition>;
  filter?: InputMaybe<EmailWhitelistPatternFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailWhitelistPatternsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentManagedServiceArgs = {
  environmentId: Scalars['UUID']['input'];
  managedServiceId: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentManagedServiceLogArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentManagedServiceLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentManagedServiceLogCondition>;
  filter?: InputMaybe<EnvironmentManagedServiceLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentManagedServiceLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentManagedServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentManagedServiceCondition>;
  filter?: InputMaybe<EnvironmentManagedServiceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentManagedServicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentTemplateCondition>;
  filter?: InputMaybe<EnvironmentTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentCondition>;
  filter?: InputMaybe<EnvironmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetTenantsBySsoTokenArgs = {
  input?: InputMaybe<GetTenantsBySsoTokenInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIdServiceConfigurationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIdServiceConfigurationByEnvironmentIdArgs = {
  environmentId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIdServiceConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IdServiceConfigurationCondition>;
  filter?: InputMaybe<IdServiceConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IdServiceConfigurationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpConfigurationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IdpConfigurationCondition>;
  filter?: InputMaybe<IdpConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IdpConfigurationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpScopeArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpScopesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IdpScopeCondition>;
  filter?: InputMaybe<IdpScopeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IdpScopesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceAccountArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceAccountByClientIdArgs = {
  clientId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceAccountPermissionAssignmentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceAccountPermissionAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceAccountPermissionAssignmentCondition>;
  filter?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceAccountPermissionAssignmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceAccountCondition>;
  filter?: InputMaybe<ServiceAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantAdminArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantAdminsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TenantAdminCondition>;
  filter?: InputMaybe<TenantAdminFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantAdminsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTokenSigningKeyArgs = {
  environmentId: Scalars['UUID']['input'];
};

export type ResetTenantAdminPasswordInput = {
  id: Scalars['String']['input'];
};

export type ResetTenantAdminPasswordPayload = {
  __typename?: 'ResetTenantAdminPasswordPayload';
  tenantAdmin?: Maybe<TenantAdmin>;
};

export type RevokeAndRotateSigningKeyPayload = {
  __typename?: 'RevokeAndRotateSigningKeyPayload';
  tokenSigningKey: TokenSigningKey;
};

export type ServiceAccount = {
  __typename?: 'ServiceAccount';
  clientId: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  /** Reads a single `Environment` that is related to this `ServiceAccount`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  isSecretGenerated?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `ServiceAccountPermissionAssignment`. */
  serviceAccountPermissionAssignments: ServiceAccountPermissionAssignmentsConnection;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
};


export type ServiceAccountServiceAccountPermissionAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceAccountPermissionAssignmentCondition>;
  filter?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceAccountPermissionAssignmentsOrderBy>>;
};

/**
 * A condition to be used against `ServiceAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ServiceAccountCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ServiceAccount` object types. All fields are combined with a logical ‘and.’ */
export type ServiceAccountFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServiceAccountFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environment` relation. */
  environment?: InputMaybe<EnvironmentFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isProtected` field. */
  isProtected?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSecretGenerated` field. */
  isSecretGenerated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ServiceAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServiceAccountFilter>>;
  /** Filter by the object’s `serviceAccountPermissionAssignments` relation. */
  serviceAccountPermissionAssignments?: InputMaybe<ServiceAccountToManyServiceAccountPermissionAssignmentFilter>;
  /** Some related `serviceAccountPermissionAssignments` exist. */
  serviceAccountPermissionAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ServiceAccount` */
export type ServiceAccountInput = {
  environmentId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

/** Represents an update to a `ServiceAccount`. Fields that are set will be updated. */
export type ServiceAccountPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceAccountPermissionAssignment = {
  __typename?: 'ServiceAccountPermissionAssignment';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  /** Reads a single `Environment` that is related to this `ServiceAccountPermissionAssignment`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  permissionId: Scalars['UUID']['output'];
  /** Reads a single `ServiceAccount` that is related to this `ServiceAccountPermissionAssignment`. */
  serviceAccount?: Maybe<ServiceAccount>;
  serviceAccountId: Scalars['UUID']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
};

/**
 * A condition to be used against `ServiceAccountPermissionAssignment` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type ServiceAccountPermissionAssignmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `permissionId` field. */
  permissionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `serviceAccountId` field. */
  serviceAccountId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ServiceAccountPermissionAssignment` object types. All fields are combined with a logical ‘and.’ */
export type ServiceAccountPermissionAssignmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServiceAccountPermissionAssignmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environment` relation. */
  environment?: InputMaybe<EnvironmentFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServiceAccountPermissionAssignmentFilter>>;
  /** Filter by the object’s `permissionId` field. */
  permissionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceAccount` relation. */
  serviceAccount?: InputMaybe<ServiceAccountFilter>;
  /** Filter by the object’s `serviceAccountId` field. */
  serviceAccountId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ServiceAccountPermissionAssignment` */
export type ServiceAccountPermissionAssignmentInput = {
  environmentId: Scalars['UUID']['input'];
  permissionId: Scalars['UUID']['input'];
  serviceAccountId: Scalars['UUID']['input'];
};

/** A connection to a list of `ServiceAccountPermissionAssignment` values. */
export type ServiceAccountPermissionAssignmentsConnection = {
  __typename?: 'ServiceAccountPermissionAssignmentsConnection';
  /** A list of edges which contains the `ServiceAccountPermissionAssignment` and cursor to aid in pagination. */
  edges: Array<ServiceAccountPermissionAssignmentsEdge>;
  /** A list of `ServiceAccountPermissionAssignment` objects. */
  nodes: Array<ServiceAccountPermissionAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceAccountPermissionAssignment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ServiceAccountPermissionAssignment` edge in the connection. */
export type ServiceAccountPermissionAssignmentsEdge = {
  __typename?: 'ServiceAccountPermissionAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ServiceAccountPermissionAssignment` at the end of the edge. */
  node: ServiceAccountPermissionAssignment;
};

/** Methods to use when ordering `ServiceAccountPermissionAssignment`. */
export enum ServiceAccountPermissionAssignmentsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PermissionIdAsc = 'PERMISSION_ID_ASC',
  PermissionIdDesc = 'PERMISSION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ServiceAccountIdAsc = 'SERVICE_ACCOUNT_ID_ASC',
  ServiceAccountIdDesc = 'SERVICE_ACCOUNT_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

/** A filter to be used against many `ServiceAccountPermissionAssignment` object types. All fields are combined with a logical ‘and.’ */
export type ServiceAccountToManyServiceAccountPermissionAssignmentFilter = {
  /** Every related `ServiceAccountPermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
  /** No related `ServiceAccountPermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
  /** Some related `ServiceAccountPermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServiceAccountPermissionAssignmentFilter>;
};

/** A connection to a list of `ServiceAccount` values. */
export type ServiceAccountsConnection = {
  __typename?: 'ServiceAccountsConnection';
  /** A list of edges which contains the `ServiceAccount` and cursor to aid in pagination. */
  edges: Array<ServiceAccountsEdge>;
  /** A list of `ServiceAccount` objects. */
  nodes: Array<ServiceAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ServiceAccount` edge in the connection. */
export type ServiceAccountsEdge = {
  __typename?: 'ServiceAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ServiceAccount` at the end of the edge. */
  node: ServiceAccount;
};

export type ServiceAccountsExportPayload = {
  __typename?: 'ServiceAccountsExportPayload';
  exportedAt: Scalars['Datetime']['output'];
  serviceAccounts: Array<ExportedServiceAccount>;
  version: Scalars['String']['output'];
};

/** Methods to use when ordering `ServiceAccount`. */
export enum ServiceAccountsOrderBy {
  ClientIdAsc = 'CLIENT_ID_ASC',
  ClientIdDesc = 'CLIENT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export enum ServiceCommand {
  Disable = 'DISABLE',
  Enable = 'ENABLE'
}

export type SetServiceAccountProtectionInput = {
  id: Scalars['String']['input'];
  isProtected: Scalars['Boolean']['input'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Triggered when a environment service state changes: */
  environmentManagedServiceStateChanged?: Maybe<EnvironmentManagedServiceStateChangedSubscriptionPayload>;
};

export type TenantAdmin = {
  __typename?: 'TenantAdmin';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  passwordChanged?: Maybe<Scalars['Boolean']['output']>;
  passwordIsSet: Scalars['Boolean']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `TenantAdmin` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TenantAdminCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `passwordChanged` field. */
  passwordChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `TenantAdmin` object types. All fields are combined with a logical ‘and.’ */
export type TenantAdminFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantAdminFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantAdminFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantAdminFilter>>;
  /** Filter by the object’s `passwordChanged` field. */
  passwordChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** Represents an update to a `TenantAdmin`. Fields that are set will be updated. */
export type TenantAdminPatch = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `TenantAdmin` values. */
export type TenantAdminsConnection = {
  __typename?: 'TenantAdminsConnection';
  /** A list of edges which contains the `TenantAdmin` and cursor to aid in pagination. */
  edges: Array<TenantAdminsEdge>;
  /** A list of `TenantAdmin` objects. */
  nodes: Array<TenantAdmin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantAdmin` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TenantAdmin` edge in the connection. */
export type TenantAdminsEdge = {
  __typename?: 'TenantAdminsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TenantAdmin` at the end of the edge. */
  node: TenantAdmin;
};

/** Methods to use when ordering `TenantAdmin`. */
export enum TenantAdminsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PasswordChangedAsc = 'PASSWORD_CHANGED_ASC',
  PasswordChangedDesc = 'PASSWORD_CHANGED_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type TenantForSsoToken = {
  __typename?: 'TenantForSSOToken';
  /** Tenant Name */
  name: Scalars['String']['output'];
  /** Tenant ID */
  tenantId: Scalars['String']['output'];
};

export type TokenSigningKey = {
  __typename?: 'TokenSigningKey';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['UUID']['output']>;
  kid: Scalars['String']['output'];
  nextRotationAt: Scalars['Datetime']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TokenSigningKeyPayload = {
  __typename?: 'TokenSigningKeyPayload';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['UUID']['output']>;
  kid: Scalars['String']['output'];
  nextRotationAt: Scalars['Datetime']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateEmailWhitelistPattern` mutation. */
export type UpdateEmailWhitelistPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `EmailWhitelistPattern` being updated. */
  patch: EmailWhitelistPatternPatch;
};

/** The output of our update `EmailWhitelistPattern` mutation. */
export type UpdateEmailWhitelistPatternPayload = {
  __typename?: 'UpdateEmailWhitelistPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailWhitelistPattern` that was updated by this mutation. */
  emailWhitelistPattern?: Maybe<EmailWhitelistPattern>;
  /** An edge for our `EmailWhitelistPattern`. May be used by Relay 1. */
  emailWhitelistPatternEdge?: Maybe<EmailWhitelistPatternsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EmailWhitelistPattern` mutation. */
export type UpdateEmailWhitelistPatternPayloadEmailWhitelistPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailWhitelistPatternsOrderBy>>;
};

/** All input for the `updateEmailWhitelistPatternRole` mutation. */
export type UpdateEmailWhitelistPatternRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `EmailWhitelistPatternRole` being updated. */
  patch: EmailWhitelistPatternRolePatch;
};

/** The output of our update `EmailWhitelistPatternRole` mutation. */
export type UpdateEmailWhitelistPatternRolePayload = {
  __typename?: 'UpdateEmailWhitelistPatternRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EmailWhitelistPattern` that is related to this `EmailWhitelistPatternRole`. */
  emailWhitelistPattern?: Maybe<EmailWhitelistPattern>;
  /** The `EmailWhitelistPatternRole` that was updated by this mutation. */
  emailWhitelistPatternRole?: Maybe<EmailWhitelistPatternRole>;
  /** An edge for our `EmailWhitelistPatternRole`. May be used by Relay 1. */
  emailWhitelistPatternRoleEdge?: Maybe<EmailWhitelistPatternRolesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EmailWhitelistPatternRole` mutation. */
export type UpdateEmailWhitelistPatternRolePayloadEmailWhitelistPatternRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailWhitelistPatternRolesOrderBy>>;
};

/** All input for the `updateEnvironment` mutation. */
export type UpdateEnvironmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Environment` being updated. */
  patch: EnvironmentPatch;
};

/** The output of our update `Environment` mutation. */
export type UpdateEnvironmentPayload = {
  __typename?: 'UpdateEnvironmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Environment` that was updated by this mutation. */
  environment?: Maybe<Environment>;
  /** An edge for our `Environment`. May be used by Relay 1. */
  environmentEdge?: Maybe<EnvironmentsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Environment` mutation. */
export type UpdateEnvironmentPayloadEnvironmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};

/** All input for the `updateIdServiceConfigurationByEnvironmentId` mutation. */
export type UpdateIdServiceConfigurationByEnvironmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `IdServiceConfiguration` being updated. */
  patch: IdServiceConfigurationPatch;
};

/** All input for the `updateIdServiceConfiguration` mutation. */
export type UpdateIdServiceConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `IdServiceConfiguration` being updated. */
  patch: IdServiceConfigurationPatch;
};

/** The output of our update `IdServiceConfiguration` mutation. */
export type UpdateIdServiceConfigurationPayload = {
  __typename?: 'UpdateIdServiceConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `IdServiceConfiguration`. */
  environment?: Maybe<Environment>;
  /** The `IdServiceConfiguration` that was updated by this mutation. */
  idServiceConfiguration?: Maybe<IdServiceConfiguration>;
  /** An edge for our `IdServiceConfiguration`. May be used by Relay 1. */
  idServiceConfigurationEdge?: Maybe<IdServiceConfigurationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IdServiceConfiguration` mutation. */
export type UpdateIdServiceConfigurationPayloadIdServiceConfigurationEdgeArgs = {
  orderBy?: InputMaybe<Array<IdServiceConfigurationsOrderBy>>;
};

/** All input for the `updateIdpConfiguration` mutation. */
export type UpdateIdpConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `IdpConfiguration` being updated. */
  patch: IdpConfigurationPatch;
};

/** The output of our update `IdpConfiguration` mutation. */
export type UpdateIdpConfigurationPayload = {
  __typename?: 'UpdateIdpConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `IdpConfiguration`. */
  environment?: Maybe<Environment>;
  /** The `IdpConfiguration` that was updated by this mutation. */
  idpConfiguration?: Maybe<IdpConfiguration>;
  /** An edge for our `IdpConfiguration`. May be used by Relay 1. */
  idpConfigurationEdge?: Maybe<IdpConfigurationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IdpConfiguration` mutation. */
export type UpdateIdpConfigurationPayloadIdpConfigurationEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpConfigurationsOrderBy>>;
};

/** All input for the `updateServiceAccountByClientId` mutation. */
export type UpdateServiceAccountByClientIdInput = {
  clientId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ServiceAccount` being updated. */
  patch: ServiceAccountPatch;
};

/** All input for the `updateServiceAccount` mutation. */
export type UpdateServiceAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ServiceAccount` being updated. */
  patch: ServiceAccountPatch;
};

/** The output of our update `ServiceAccount` mutation. */
export type UpdateServiceAccountPayload = {
  __typename?: 'UpdateServiceAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `ServiceAccount`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ServiceAccount` that was updated by this mutation. */
  serviceAccount?: Maybe<ServiceAccount>;
  /** An edge for our `ServiceAccount`. May be used by Relay 1. */
  serviceAccountEdge?: Maybe<ServiceAccountsEdge>;
};


/** The output of our update `ServiceAccount` mutation. */
export type UpdateServiceAccountPayloadServiceAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceAccountsOrderBy>>;
};

/** All input for the `updateTenantAdmin` mutation. */
export type UpdateTenantAdminInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `TenantAdmin` being updated. */
  patch: TenantAdminPatch;
};

/** The output of our update `TenantAdmin` mutation. */
export type UpdateTenantAdminPayload = {
  __typename?: 'UpdateTenantAdminPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TenantAdmin` that was updated by this mutation. */
  tenantAdmin?: Maybe<TenantAdmin>;
  /** An edge for our `TenantAdmin`. May be used by Relay 1. */
  tenantAdminEdge?: Maybe<TenantAdminsEdge>;
};


/** The output of our update `TenantAdmin` mutation. */
export type UpdateTenantAdminPayloadTenantAdminEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantAdminsOrderBy>>;
};
